import "./styles.css"
import type { CenteredMessagePageProps } from "@site-types/components/centeredMessagePage"

export function CenteredMessagePage({
  className,
  title,
  children,
  linkHref,
  linkLabel,
}: CenteredMessagePageProps) {
  return (
    <div className={`container ${className}`}>
      <h1>{title}</h1>
      <div>{children}</div>
      <a
        className="message-page-link"
        href={linkHref}
      >
        {linkLabel}
      </a>
    </div>
  )
}
